"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyToMangoPayCurrency = void 0;
const transformCurrencyToCurrencyISO_1 = require("./transformCurrencyToCurrencyISO");
function transformCurrencyToMangoPayCurrency(currency) {
    return currency ? (0, transformCurrencyToCurrencyISO_1.transformCurrencyToCurrencyISO)(currency) : "EUR";
}
exports.transformCurrencyToMangoPayCurrency = transformCurrencyToMangoPayCurrency;
//# sourceMappingURL=transformCurrencyToMangoPayCurrency.js.map